<template>
  <div class="help-text-container" :style="{ borderLeft: '6px solid ' + (color || '#ccc') }" data-test="div-help-text">
    <slot />
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  props: {
    color: {
      type: String,
      default: '#ccc',
    },
  },
});
</script>

<style scoped>
.help-text-container {
  padding-left: 12px;
  border: 1px solid var(--mds-color-dark-hover);
  border-radius: 8px;
  padding: 10px;
}
</style>
